/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const RssLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M3 17a4 4 0 0 1 4 4H3zm0-7a11 11 0 0 1 11 11h-2a9 9 0 0 0-9-9zm0-7a18 18 0 0 1 18 18h-2A16 16 0 0 0 3 5z" />
  </Icon>
);
